import { Component, OnInit, ViewChild, EventEmitter, Output, Input, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as forge from 'node-forge';
import { arrayBufferToString } from '../../util/format';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-certificado-pfx',
  templateUrl: './modal-certificado-pfx.component.html',
  styleUrls: [ './modal-certificado-pfx.component.scss' ],
})
export class ModalCertificadoPfxComponent implements OnInit {

  @Input() corPrimaria: string;
  @Output() fecharModal = new EventEmitter();
  @ViewChild('arquivoPfx') arquivoPfx: ElementRef;
  state = false

  form: FormGroup = this.formBuilder.group({
    arquivo: new FormControl(null, Validators.required),
    senha: new FormControl(null, Validators.required),
  });

  fileReader = new FileReader();

  constructor(
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private loading: NgxSpinnerService,
  ) {

  }

  ngOnInit() {
    this.fileReader.onload = (e) => {
      let password = this.form.get('senha').value,
        contents = (<FileReader>e.target).result;

      try {
        let pkcs12Der = arrayBufferToString(contents),
          pkcs12Asn1 = forge.asn1.fromDer(pkcs12Der),
          pkcs12 = forge.pkcs12.pkcs12FromAsn1(pkcs12Asn1, false, password);
          let certBag = pkcs12.getBags({ bagType: forge.pki.oids.certBag })[ forge.pki.oids.certBag ][ 0 ];
          let certificate = forge.pki.certificateToPem(certBag.cert);

        this.fechar(certificate);
      } catch (_exception) {
        this.toast.error('Não foi possivel realizar a leitura deste arquivo');
        // Mensagem de erro
        console.warn(_exception);
      }

    };
  }

  changeState(data) {
    console.log('data', data)
    this.state = true;
  }

  extrairChave() {
    var file = this.arquivoPfx.nativeElement.files[ 0 ];

    if (file) {
      this.fileReader.readAsArrayBuffer(file);
    } else {
      this.toast.error('Não foi possivel realizar a leitura deste arquivo');
      // Mensagem de erro
    }
  }


  fechar(data?) {
    this.fecharModal.emit(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-certificado-pfx/modal-certificado-pfx.component.ts